import { useCellOpenCellSchedules } from "./useCellOpenCellSchedules"
import Loader from "@/components/Loader"
import { Icon, IconColor } from "@/components/shared/Icon"
import { Table } from "@/components/shared/Table"
import { Column } from "@/components/shared/Table/types"
import { useErrorMessage } from "@/hooks/useErrorMessage"
import { OpenCellScheduleRow } from "@/pages/Settings/OpenCellSchedules/types"
import {
   formatTime,
   uses12HourClock,
} from "@/pages/Settings/OpenCellSchedules/utils"
import { WeekdayPills } from "@/pages/Settings/OpenCellSchedules/WeekdayPills"
import "./index.scss"

const COLUMNS: Column<OpenCellScheduleRow>[] = [
   {
      key: "levelName",
      label: "Level",
      sortable: true,
      width: 225,
      renderCell: ({ row }) => (
         <div className="table__cell-content table__cell-content--with-icon table__cell-content--auto-height">
            {row.levelIcon && (
               <Icon
                  name={row.levelIcon}
                  color={IconColor.HONOLULU_BLUE}
                  size="12"
               />
            )}
            <div className="table__cell-text">{row.levelName}</div>
         </div>
      ),
   },
   {
      key: "startTime",
      label: "Time Interval",
      sortable: true,
      width: 200,
      renderCell: ({ row }) => (
         <div className="table__cell-content table__cell-content--auto-height">
            <div className="table__cell-text">
               <span className="cell-open-cell-schedules__time">
                  {formatTime(row.startTime, uses12HourClock())}
               </span>{" "}
               -{" "}
               <span className="cell-open-cell-schedules__time">
                  {formatTime(row.endTime, uses12HourClock())}
               </span>
            </div>
         </div>
      ),
   },
   {
      key: "weekdays",
      label: "Weekdays",
      width: 400,
      renderCell: ({ row }) => (
         <div className="table__cell-content table__cell-content--auto-height">
            <WeekdayPills value={row.weekdays} />
         </div>
      ),
   },
]

const OpenCellSchedules = () => {
   const { schedules, isLoading, error } = useCellOpenCellSchedules()
   const errorMessage = useErrorMessage([error])

   if (isLoading && schedules.length === 0) return <Loader />

   return (
      <Table<OpenCellScheduleRow>
         columns={COLUMNS}
         rows={schedules}
         initialSortField="levelName"
         className="cell-open-cell-schedules"
         editable={false}
         error={errorMessage}
      />
   )
}

export default OpenCellSchedules
